import {LogParam} from '../../sql/message/LogParam';
import {SqlParam} from '../../sql/message/SqlParam';

export class LogSiphonConfiguration {
bu: string;
criterias: SqlParam[];
domain: string;
params: LogParam[];
schema: string;
stepLevel: number | null;
tableName: string;
vision: string;
}

